var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"text":_vm.status.name,"variant":_vm.color(_vm.status),"left":"","size":"sm"}},_vm._l((_vm.options),function(option,key){return (option !== 'submitting')?_c('b-dropdown-item',{key:option,on:{"click":function($event){_vm.changeStatus(key)}}},[_vm._v(_vm._s(option))]):_vm._e()}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486f4011","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/status-user/status.html
// module id = null
// module chunks = 